import SearchBase from './SearchBase';

export default SearchBase;
